import { useContext } from "react";

import ClientContext from "../context/ClientContext";

export default function useCurrentClient() {
    const data = useContext(ClientContext);
    return data?.client;
}
